// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"94":"Login","326":"cadastrar"}[chunkId] || chunkId) + "." + {"94":"380af416","326":"46303474","815":"0dfc6c6d"}[chunkId] + ".css";
};